export default {
  items: [
    {
      _name: 'CSidebarNav',
      _children: [
        {
          _name: 'CSidebarNavItem',
          name: 'Trang chủ',
          icon: 'cil-speedometer',
          to: '/dashboard.html'
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Quản lý đài truyền thanh',
          icon: 'cil-bullhorn',
          to: '/audio-station-management/managed-audio-station.html'
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Quản lý nhóm bảng điện tử',
          icon: 'cil-airplay',
          to: '/screen-station-management/managed-screen-station.html'
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản lý thiết bị',
          icon: 'cil-devices',
          items: [
            {
              name: 'Thiết bị phát thanh',
              to: '/devices-management/audio-devices.html',
            },
            {
              name: 'Thiết bị bảng điện tử',
              to: '/devices-management/screen-devices.html',
            }
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Biên tập phát thanh',
          icon: 'cil-audio',
          items: [
            {
              name: 'Biên tập bản tin phát thanh',
              to: '/audio-editor/upload-audio.html',
            },
            {
              name: 'Chuyển đổi văn bản sang giọng đọc',
              to: '/audio-editor/text-to-speech.html',
            },
            {
              name: 'Ghép tệp âm thanh',
              to: '/audio-editor/merge-file.html',
            },
            {
              name: 'Ghi âm tệp âm thanh',
              to: '/audio-editor/record-file.html',
            },
            // {
            //   name: 'Cắt file âm thanh',
            //   to: '/audio-editor/cut-file.html',
            // },
            {
              name: 'Bản tin được gửi từ TW',
              to: '/audio-editor/file-from-central.html',
            },
            {
              name: 'Gửi tin tới đài truyền thanh',
              to: '/audio-editor/send-to-station.html',
            },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Biên tập bảng tin điện tử',
          icon: 'cil-file',
          items: [
            {
              name: 'Biên tập nội dung bảng điện tử',
              to: '/screen-editor/upload-screen.html',
            },
            {
              name: 'Biên tập danh sách phát bảng điện tử',
              to: '/screen-editor/play-list.html',
            },
            {
              name: 'Nội dung phát được gửi từ TW',
              to: '/screen-editor/file-from-central.html',
            },
            {
              name: 'Gửi nội dung phát tới nhóm bảng tin điện tử',
              to: '/screen-editor/send-to-station.html',
            },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản lý phát thanh',
          icon: 'cil-book',
          items: [
            {
              name: 'Bản tin phát thanh đã biên tập',
              to: '/files-device-management/managed-files.html',

            },
            {
              name: 'Bản tin phát thanh đã phát',
              to: '/files-device-management/managed-files-broadcast.html',

            },
            {
              name: 'Bản tin phát thanh đang phát',
              to: '/files-device-management/managed-files-playing.html',
            },
            {
              name: 'Nhật ký phát thanh',
              to: '/files-device-management/managed-files-history.html',

            },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản lý nội dung bảng điện tử',
          icon: 'cil-book',
          items: [
            {
              name: 'Nội dung bảng điện tử đã biên tập',
              to: '/files-screen-management/managed-files.html',

            },
            {
              name: 'Nội dung bảng điện tử đã phát',
              to: '/files-screen-management/managed-files-broadcast.html',

            },
            {
              name: 'Nội dung bảng điện tử đang phát',
              to: '/files-screen-management/managed-files-playing.html',
            },
            {
              name: 'Nhật ký phát bảng điện tử',
              to: '/files-screen-management/managed-files-history.html',

            },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Báo cáo thống kê',
          icon: 'cil-bar-chart',
          items: [
            {
              name: 'Đài truyền thanh',
              to: '/report-management/audio-stations.html',
            },
            {
              name: 'Thiết bị phát thanh',
              to: '/report-management/audio-devices.html',
            },
            {
              name: 'Thiết bị bảng điện tử',
              to: '/report-management/screen-devices.html',
            },
            {
              name: 'Bản tin phát thanh đã phát',
              to: '/report-management/audio-file-broadcast.html',
            },
            {
              name: 'Nội dung bảng điện tử đã phát',
              to: '/report-management/screen-file-broadcast.html',
            },
            {
              name: 'Báo cáo tài khoản',
              to: '/report-management/users.html',
            },
            {
              name: 'Gửi báo cáo hoạt động TTCS cho TW',
              to: '/report-management/send-TW.html',
            },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản trị',
          icon: 'cil-settings',
          items: [
            {
              name: 'Quản lý cấu hình API',
              to: '/administrator/contractor-information.html',
            },
            {
              name: 'Quản trị danh mục lĩnh vực',
              to: '/administrator/file-type.html',
            },
            {
              name: 'Quản trị danh mục địa danh hành chính',
              to: '/administrator/location.html',
            },
            {
              name: 'Nhật ký hoạt động',
              to: '/administrator/user-activity-log.html',
            },
          ]
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Phản ánh của người dân',
          icon: 'cil-voice-over-record',
          to: '/residents-feedback-management/managed-residents-feedback.html'
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Quản lý tài liệu',
          icon: 'cil-book',
          to: '/document-management/managed-document.html'
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Hướng dẫn sử dụng',
          icon: 'cil-hd',
          to: '/user-manual.html'
        },
      ]
    },
  ]
}
